/** @license MIT License (c) copyright 2010-2017 original author or authors */

import { at } from './at'

export const now = x => at(0, x)
